/* eslint-disable camelcase */
import { fetchAll } from '@/api/promotion'

const state = {
  list: [],
}

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list
  },
}

const actions = {
  list({ commit }) {
    return new Promise((resolve, reject) => fetchAll()
      .then(response => {
        console.log('store list response', response)
        const { data } = response
        commit('SET_LIST', data.items)
        resolve(data)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)
      }))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
